import { CHAT_TYPE } from "./../types/navigation-mode";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AppState {
  userId: string;
  setUserId: (userId: string) => void;

  micInstruction: string;
  setMicInstruction: (instruction: string) => void;

  showNavError: boolean;
  setShowNavError: (value: boolean) => void;

  isVoiceChatMode: boolean;
  setVoiceChatMode: (value: boolean) => void;

  isChatOpen: boolean;
  setIsChatOpen: (value: boolean) => void;

  hasUserInteraction: boolean;
  setHasUserInteraction: (value: boolean) => void;

  chatType: string;
  setChatType: (value: string) => void;

  isShareOpen: boolean;
  setIsShareOpen: (value: boolean) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set, get) => ({
      userId: "",
      setUserId: (userId: string) => set({ userId: userId }),

      micInstruction: "mic_permission_generic",
      setMicInstruction: (instruction: string) =>
        set({ micInstruction: instruction }),

      showNavError: false,
      setShowNavError: (showNavError: boolean) =>
        set({ showNavError: showNavError }),

      isVoiceChatMode: false,
      setVoiceChatMode: (value: boolean) => set({ isVoiceChatMode: value }),

      hasUserInteraction: false,
      setHasUserInteraction: (value: boolean) =>
        set({ hasUserInteraction: value }),

      isChatOpen: false,
      setIsChatOpen: (value: boolean) => set({ isChatOpen: value }),

      chatType: CHAT_TYPE.NAVIGATION,
      setChatType: (value: string) => set({ chatType: value }),

      isShareOpen: false,
      setIsShareOpen: (value: boolean) => set({ isShareOpen: value }),
    }),
    {
      name: "app-storage", // localStorage key
      partialize: (state) => ({
        userId: state.userId,
      }),
    }
  )
);
